import fetchAPI from '../../../utils/fetchAPI';
import { TBiddingClient } from 'types/TBidding';

type TParams = {
  itemId: string;
  bidAmountCents: number;
  message: string;
  phoneNumber: string;
  xsrfToken: string;
};

export default async function placeBid({
  itemId,
  bidAmountCents,
  message,
  phoneNumber,
  xsrfToken,
}: TParams): Promise<TBiddingClient> {
  try {
    return await fetchAPI({
      url: '/v/api/place-bid',
      method: 'POST',
      xsrfToken,
      payload: {
        itemId,
        bidAmountCents,
        message,
        phoneNumber,
      },
    });
  } catch {
    return {};
  }
}
